import { render, staticRenderFns } from "./AccountWidget.vue?vue&type=template&id=c439e644"
import script from "./AccountWidget.vue?vue&type=script&lang=ts"
export * from "./AccountWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports